import { render, staticRenderFns } from "./TBFCardToggle.vue?vue&type=template&id=57d0e023&"
import script from "./TBFCardToggle.vue?vue&type=script&lang=js&"
export * from "./TBFCardToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports